import styles from '../../styles/Loader.module.css';

const NotesInboxSkeleton = ({itemCount = 4}) => {
    return(
    <div className='clientCard'>
        <div className={styles.skeletonNotesItemHeader}>
            <div className={styles.skeletonNotesInboxHeaderText}></div>
        </div>
        <div className={styles.skeletonNotesItemFilterBody}>
            <div className={styles.skeletonNotesItemSearchBar}>
                <div className={`${styles.flexGrowExtra} me-1`}>
                    <div className={styles.skeletonNotesInboxSearch}></div>
                </div>
                <div className={styles.flexGrowFull}>
                    <div className={styles.skeletonNotesInboxFilterBtn}></div>
                </div>
            </div>
            <div className='d-flex justify-content-between align-items-center mt-2'>
                <div className={styles.skeletonNotesInboxFilterText}></div>
                <div className='d-flex align-items-center'>
                    <div className={`${styles.skeletonNotesInboxFilterBtn} me-1`}></div>
                    <div className={styles.skeletonNotesInboxFilterBtn}></div>
                </div>
            </div>
        </div>
        {Array.from({length: itemCount},(_,index) => (
                <div key={index} className={styles.skeletonNotesInboxNoteItem}>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className={styles.skeletonNoteInboxTextUser}></div>
                        <div className={styles.skeletonNoteInboxTextDate}></div>
                    </div>
                    <div className={styles.skeletonNotesInboxNoteTextFull}></div>
                    <div className={styles.skeletonNotesInboxNoteType}></div>
                </div>
            ))}
    </div>
    )
}

export default NotesInboxSkeleton;